import * as React from 'react';
import { styled, alpha } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';
import { AddBox, ArrowDropDown, ArrowDropUp, Delete, MoreVert, PictureAsPdf, Rtt, Save, SaveAs, Settings, SmartButton, Square, ViewColumn } from '@mui/icons-material';
import { ListItemIcon, ListSubheader } from '@mui/material';

const StyledMenu = styled((props) => (
    <Menu
        elevation={0}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
        }}
        {...props}
    />
))(({ theme }) => ({
    '& .MuiPaper-root': {
        borderRadius: 6,
        marginTop: theme.spacing(1),
        minWidth: 180,
        color: 'rgb(55, 65, 81)',
        boxShadow:
            'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
        '& .MuiMenu-list': {
            padding: '4px 0',
        },
        '& .MuiMenuItem-root': {
            '& .MuiSvgIcon-root': {
                fontSize: 18,
                color: theme.palette.text.secondary,
                marginRight: theme.spacing(1.5),
            },
            '&:active': {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    theme.palette.action.selectedOpacity,
                ),
            },
        },
        ...theme.applyStyles('dark', {
            color: theme.palette.grey[300],
        }),
    },
}));

export default function MatchDocumentDividerMenu({ toggleDivider, toggleMultiDivider, disabled }) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };



    return (
        <div>
            <Button
                id="cow-button"
                aria-controls={open ? 'cow-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                variant={open ? 'contained' : "outlined"}
                disableElevation
                size="small"
                color="light"
                disabled={disabled}
                onClick={handleClick}
                startIcon={<AddBox />}
                endIcon={open ?<ArrowDropUp />: <ArrowDropDown />}

            >
                aggiungi interruzione
            </Button>
            <StyledMenu
                id="cow-menu"
                MenuListProps={{
                    'aria-labelledby': 'cow-button',
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                    <MenuItem onClick={() => { toggleDivider(); handleClose() }} disableRipple>
                    singola (dopo elemento selezionato)
                    </MenuItem>
                    <MenuItem onClick={() => { toggleMultiDivider(); handleClose() }} disableRipple>
                    tra ogni premio
                    </MenuItem>
                    <MenuItem onClick={() => { toggleMultiDivider(true); handleClose() }} disableRipple>
                    tra ogni gara
                    </MenuItem>
            </StyledMenu>
        </div>
    );
}